module.exports = __webpack_public_path__ + "static/media/Reports.98527672.png";